function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import GroupOverviewNotesForm from './GroupOverviewNotesForm';
import GroupOverviewNotesItem from './GroupOverviewNotesItem';
import groupOverviewNotesService from '@rd-web-markets/shared/dist/services/project_report/group_overview_note.service';
const GroupOverviewNotesList = _ref => {
  let {
    elster,
    setElster
  } = _ref;
  const [loading, setLoading] = useState(false);
  const [newNote, setNewNote] = useState({
    content: ''
  });
  const handleNoteChange = e => {
    setNewNote(_objectSpread(_objectSpread({}, newNote), {}, {
      'content': e.target.value
    }));
  };
  const addNote = useErrorHandling(useCallback(async () => {
    setLoading(true);
    const createdNote = await groupOverviewNotesService.create(elster.id, newNote);
    const updatedNotes = elster.group_overview_notes;
    updatedNotes.push(createdNote);
    setNewNote({
      content: ''
    });
    setElster(_objectSpread(_objectSpread({}, elster), {}, {
      group_overview_notes: updatedNotes
    }));
    setLoading(false);
  }, [newNote]));
  const removeNote = useErrorHandling(useCallback(async noteId => {
    if (window.confirm('Are you sure ?')) {
      await groupOverviewNotesService.delete(elster.id, noteId);
      let updatedNotes = elster.group_overview_notes;
      updatedNotes = updatedNotes.filter(note => note.id !== noteId);
      setElster(_objectSpread(_objectSpread({}, elster), {}, {
        group_overview_notes: updatedNotes
      }));
    }
  }, [elster]));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GroupOverviewNotesForm, {
    newNote: newNote,
    handleNoteChange: handleNoteChange,
    addNote: addNote,
    loading: loading
  }), (elster.group_overview_notes || []).map((note, index) => {
    return /*#__PURE__*/React.createElement(GroupOverviewNotesItem, {
      removeNote: removeNote,
      note: note,
      index: index
    });
  }));
};
export default GroupOverviewNotesList;